var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 40h40v4H10zm0-24h40v4H10zm0 12h40v4H10z"}));
}

Menu.defaultProps = {"id":"icon-menu","viewBox":"0 0 60 60"};

module.exports = Menu;

Menu.default = Menu;
